// GoogleTranslate.js
import "./googletranslate.css";

const GoogleTranslate = () => {
  return (
    <div className="translate-container d-block">
      <div id="google_translate_element"></div>
    </div>
  );
};

export default GoogleTranslate;
